import CHILD_ROUTE from './child-route';

export const REGION_ROUTE_KEY = {
  AUVERGNE: 'auvergne-rhone-alpes',
  BOURGOGNE: 'bourgogne-franche-comte',
  BRETAGNE: 'bretagne',
  CENTRE: 'centre-val-de-loire',
  CORSE: 'corse',
  DOM: 'dom',
  GRAND_EST: 'grand-est',
  HAUTS_DE_FRANCE: 'hauts-de-france',
  ILE_DE_FRANCE: 'ile-de-france',
  NATIONAL: 'national',
  NORMANDIE: 'normandie',
  NOUVELLE_AQUITAINE: 'nouvelle-aquitaine',
  OCCITANIE: 'occitanie',
  PACA: 'paca',
  PAYS_DE_LA_LOIRE: 'pays-de-la-loire',
  INTERNATIONAL: 'international',
};

const regionRoutes = Object.values(REGION_ROUTE_KEY).map((region) => ({
  id: `HOME-${region}`,
  fr: `:regionSlug(${region})`,
  en: `:regionSlug(${region})`,
  fileLoader: /* istanbul ignore next */ () => import('../../pages/Home'),
}));

/**
 * List of absolute routes
 */
const routes = [
  {
    id: 'HOME',
    fr: '',
    en: '',
    fileLoader: /* istanbul ignore next */ () => import('../../pages/Home'),
  },
  ...regionRoutes,
  {
    id: 'AGENDA',
    fr: 'agenda',
    en: 'agenda',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Agenda'),
  },
  {
    id: 'NEWSROOM',
    fr: 'espace-presse',
    en: 'newsroom',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Newsroom'),
    children: [
      {
        ...CHILD_ROUTE.MEDIA,
        fileLoader: /* istanbul ignore next */ () =>
          import('../../containers/PopOver/MediaPopOverWithSearch'),
      },
    ],
  },
  // {
  //   id: 'HUBACTU',
  //   fr: 'hub-actus',
  //   en: 'news-hub',
  //   fileLoader: /* istanbul ignore next */ () =>
  //     import('../../pages/HubActualites'),
  // },
  {
    id: 'ARTICLE',
    fr: 'article/:articleUid',
    en: 'article/:articleUid',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Article'),
    children: [CHILD_ROUTE.MEDIA],
  },
  {
    id: 'GOUVERNANCE',
    fr: 'organigramme',
    en: 'gouvernance',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Gouvernance'),
    children: [CHILD_ROUTE.CONTACT],
  },
  {
    id: 'GROUP_HISTORY',
    fr: 'histoire-du-groupe',
    en: 'group-history',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/GroupHistory'),
  },
  {
    id: 'BRANCH_ACTIVITIES',
    fr: 'activites',
    en: 'branch-activities',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/BranchActivities'),
  },
  {
    id: 'OUR_BRANDS',
    fr: 'vers-nos-marques',
    en: 'our-brands',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/OurBrands'),
  },
  {
    id: 'SEARCH',
    fr: 'recherche/:query?',
    en: 'search/:query?',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Search'),
  },
  {
    id: 'FINANCIAL_DEBT',
    fr: 'dette',
    en: 'financial-debt',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Debt'),
  },
  {
    id: 'FINANCIAL_RATING',
    fr: 'notations',
    en: 'financial-rating',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Rating'),
  },
  {
    id: 'FINANCIAL_PUBLICATION',
    fr: 'publications',
    en: 'financial-publication',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Publication'),
  },
  {
    id: 'FINANCIAL_PUBLICATION_YEAR',
    fr: 'publications/:year',
    en: 'financial-publication/:year',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/Publication'),
    children: [
      {
        ...CHILD_ROUTE.MEDIA,
        fileLoader: /* istanbul ignore next */ () =>
          import('../../containers/PopOver/MediaPublicationPopOverWithList'),
      },
    ],
  },
  {
    id: 'FINANCIAL_PRESS_RELEASE',
    fr: 'communiques-de-presse',
    en: 'financial-press-release',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/PressRelease'),
  },
  {
    id: 'FINANCIAL_PRESS_RELEASE_YEAR',
    fr: 'communiques-de-presse/:year',
    en: 'financial-press-release/:year',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/PressRelease'),
    children: [
      {
        ...CHILD_ROUTE.MEDIA,
        fileLoader: /* istanbul ignore next */ () =>
          import('../../containers/PopOver/MediaPressReleasePopOverWithList'),
      },
    ],
  },
  {
    id: 'FINANCIAL_KEY_FIGURES',
    fr: 'chiffres-cles',
    en: 'financial-key-figures',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Financial/KeyFigures'),
  },
  {
    id: 'REWARDED_INNOVATION_PAGE',
    fr: 'innovations-recompensees',
    en: 'rewarded-innovations',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/RewardedInnovationPage'),
    children: [CHILD_ROUTE.REWARDED_INNOVATION],
  },
  {
    id: 'POSTMEN',
    fr: 'les-postiers',
    en: 'postmen',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/Postmen'),
    children: [CHILD_ROUTE.MEDIA],
  },
  {
    id: 'PUBLIC_SERVICE_MISSIONS',
    fr: 'missions-de-service-public',
    en: 'public-service-missions',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/PublicServiceMissions'),
    children: [CHILD_ROUTE.MEDIA],
  },
  {
    id: 'INNOVATION_BY_LA_POSTE',
    fr: 'innovation-par-la-poste',
    en: 'innovation-by-la-poste',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/InnovationByLaPoste'),
    children: [CHILD_ROUTE.MEDIA],
  },
  {
    id: 'LA_POSTE_EN_4',
    fr: 'la-poste-se-plie-en-4',
    en: 'la-poste-se-plie-en-4',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../pages/LaPosteEn4/LaPosteEn4'),
  },
  {
    id: 'CONTACT_PAGE',
    fr: 'contact',
    en: 'contact',
    fileLoader: /* istanbul ignore next */ () =>
      import('../../containers/ContactPage'),
    children: [CHILD_ROUTE.CONTACT],
  },
];

export default routes;
